module.exports = __webpack_public_path__ + "static/media/CM1有效载荷指标.8f7b8c2e.jpg";